import { EGeoName } from '../../types/share';

export const REGIONS_OPTIONS = [
  { value: EGeoName.Msk, label: 'Москва' },
  { value: EGeoName.Mo, label: 'Московская область' },
  { value: EGeoName.Spb, label: 'Санкт-Петербург' },
  { value: EGeoName.Lo, label: 'Ленинградская область' },
  { value: EGeoName.Other, label: 'Регионы' },
];
